const initialState = {
  host: '',
  step: 1,
  branch: {},
  isOpen: true,
  schedule: {
    availableDays: [],
    availableHours: [],
    initializing: true,
    isMounted: false,
  },
  visit: {
    id: null,
    cancelVisitModalOpen: false,
    status: 1,
    visitDurationInMinutes: 0,
    date: '',
    hour: '',
    timezone: '',
    initializing: true,
    loadingMonth: true,
    loadingHours: true,
    canceling: false,
    confirming: false,
    error: false,
    errorType: 'generic',
  },
  property: {
    id: null,
    location: '',
    name: '',
    thumbnail: '',
    gmt: '',
  },
  company: {
    thumbnail: '',
  },
  participants: [],
  form: {
    fullname: {
      value: '',
      error: false,
      focused: false,
      needed: true,
      required: true,
      restrictedValue: '',
      errorKey: '',
      isCustom: false,
    },
    email: {
      value: '',
      error: false,
      focused: false,
      needed: true,
      required: true,
      restrictedValue: '',
      errorKey: '',
      isCustom: false,
    },
    phone: {
      value: '',
      error: false,
      focused: false,
      needed: true,
      required: true,
      restrictedValue: '',
      errorKey: '',
      isCustom: false,
    },
    comment: {
      value: '',
      error: false,
      focused: false,
      needed: true,
      required: false,
      restrictedValue: '',
      errorKey: '',
      isCustom: false,
    },
  }
}

export default initialState
